import { render } from "./MenuItemsComponent.vue?vue&type=template&id=43ad4dac&scoped=true"
import script from "./MenuItemsComponent.vue?vue&type=script&lang=js"
export * from "./MenuItemsComponent.vue?vue&type=script&lang=js"

import "./MenuItemsComponent.vue?vue&type=style&index=0&id=43ad4dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ad4dac"]])

export default __exports__